module.exports = __webpack_public_path__ + "static/media/logo-queplanta.5f3eeb59.png";